export default __webpack_public_path__ + "static/media/andres3.064b7ad9.jpg";